import React, { useState } from "react"
import { createContainer } from "unstated-next"
import IResult from "../models/result/IResult";
import * as voicifyApi from '../api';
import ApplicationVariable from "../models/applications/ApplicationVariable";

function useApplicationVariablesContainer() {
    const [applicationVariables, setApplicationVariables] = useState([] as ApplicationVariable[]);
    const [selectedApplicationVariable, setSelectedApplicationVariable] = useState({} as ApplicationVariable);
    const [errors, setErrors] = useState([] as string[]);
    const [currentAppId, setCurrentAppId] = useState<string | null>(null);

    const loadApplicationVariablesByApplicationId = async (applicationId: string, baseUrl?: string): Promise<IResult<ApplicationVariable[]>> => {
        try {
            const result = await voicifyApi.getApplicationVariablesByApplicationId(applicationId, baseUrl);
            if (result.resultType == "Ok") {
                setApplicationVariables(result.data);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const loadApplicationVariableById = async (applicationVariableId: string): Promise<IResult<ApplicationVariable>> => {
        try {
            const result = await voicifyApi.getApplicationVariableById(applicationVariableId);
            if (result.resultType == "Ok") {
                setSelectedApplicationVariable(result.data);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const createApplicationVariable = async (model: ApplicationVariable): Promise<IResult<ApplicationVariable>> => {
        try {
            const result = await voicifyApi.createApplicationVariable(model);
            if (result.resultType == "Ok") {
                setApplicationVariables([...applicationVariables, result.data]);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const updateApplicationVariable = async (applicationVariableId: string, model: ApplicationVariable): Promise<IResult<ApplicationVariable>> => {
        try {
            const result = await voicifyApi.updateApplicationVariable(applicationVariableId, model);
            if (result.resultType == "Ok") {
                const updatedVariables = applicationVariables.map(variable =>
                    variable.id === applicationVariableId ? result.data : variable
                );
                setApplicationVariables(updatedVariables);
                setSelectedApplicationVariable(result.data);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const deleteApplicationVariable = async (applicationVariableId: string): Promise<IResult<ApplicationVariable>> => {
        try {
            const result = await voicifyApi.deleteApplicationVariable(applicationVariableId);
            if (result.resultType == "Ok") {
                const filteredVariables = applicationVariables.filter(variable => variable.id !== applicationVariableId);
                setApplicationVariables(filteredVariables);
            }
            else {
                setErrors(result.errors);
            }
            return result;
        } catch (e) {
            setErrors(e);
        }
    }

    const clearErrors = () => {
        setErrors([]);
    }

    return {
        applicationVariables,
        setApplicationVariables,
        selectedApplicationVariable,
        setSelectedApplicationVariable,
        errors,
        setErrors,
        loadApplicationVariablesByApplicationId,
        loadApplicationVariableById,
        createApplicationVariable,
        updateApplicationVariable,
        deleteApplicationVariable,
        clearErrors,
        setCurrentAppId
    };
}

const ApplicationVariablesContainer = createContainer(useApplicationVariablesContainer);
export default ApplicationVariablesContainer;
